
import { create } from "zustand";
import { API_BASE_URL } from "../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../utils/apiCall";

const SecondaryCollectionReportStore = create((set, get) => ({

    secondaryReportsData: [],
    loading: false,
    error: false,

    fetchSecondaryCollectionReportsApi: async (fromDate,toDate,zoneId,vehicleNumber) => {
        set({ loading: true, error: null });
        try {
            const url = 
            `${API_BASE_URL}api/SecondaryCollection/SecondaryCollectionTransportationReport?fromDate=${fromDate}&toDate=${toDate}&zone=${zoneId}&vehicleNumber=${vehicleNumber}`;

            const reportsData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                secondaryReportsData: Array.isArray(reportsData) ? reportsData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            if (error.response && error.response.status === 404) {
                set({
                    secondaryReportsData: [], // fixed typo: secondaryReportsData → secondaryReportsData
                    error: "No Data found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },
}));

export default SecondaryCollectionReportStore
